/*
 * PAWS & PEARLS — THE MUSE / PEARL BALLOON MUSIC ADD-ON V1
 * Prepared by Jeeves XXIII, 26 October 2026
 * STATUS: INSTALLATION CANDIDATE — NOT SHOPIFY-TESTED
 * Approved audio selected by Madam: Gregor Quendel, Pixabay 192651
 * Uses user's existing Shopify Content Files URL, not a duplicate upload.
 * Original V18 balloon flight script, motion, timing, 32 pearls: UNCHANGED.
 * House sound preference: read-only window.ppHouseSound.isEnabled().
 * No new mute button, audio preferences, local storage, or random events.
 * Companion playback element is limited to The Muse's button click and respects
 * the existing House sound preference. It does not replace ppHouseSound.
 */
(function(){
  'use strict';
  var stage = document.getElementById('pp-muse-balloon-stage');
  if(!stage || stage.dataset.ppBalloonMusicV1 === '1') return;
  var balloon = stage.querySelector('button.pp-balloon');
  if(!balloon) return;
  stage.dataset.ppBalloonMusicV1 = '1';

  // The user has already uploaded this exact recording to Shopify Content > Files.
  // Preserve the entire existing CDN URL, including its version query string.
var AUDIO_URL = 'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/aidanpinsent-chocolate-galaxy-waltz-background-music-235343.mp3?v=1793168190';
var CUE_END_MS = 83000;
var FADE_START_MS = 73000;
  var BASE_VOLUME = 0.28;       // Restrained, subject to Madam's live listening
  var player = null;
  var running = false;
  var begunAt = 0;
  var tickId = 0;
  var endId = 0;
  var disposed = false;

  function houseAllowsSound(){
    var house = window.ppHouseSound;
    if(!house || typeof house.isEnabled !== 'function') return false;
    try { return house.isEnabled() === true; }
    catch(_error){ return false; }
  }
  function stop(){
    running = false;
    if(tickId){ window.clearInterval(tickId); tickId=0; }
    if(endId){ window.clearTimeout(endId); endId=0; }
    if(player){
      try{player.pause(); player.currentTime=0; player.volume=BASE_VOLUME;}
      catch(_error){}
    }
  }
  function update(){
    if(!running || disposed) return;
    if(!houseAllowsSound()){stop();return;}
    var elapsed = performance.now()-begunAt;
    if(elapsed>=CUE_END_MS){stop();return;}
    if(elapsed>=FADE_START_MS && player){
      var portion = Math.max(0, (CUE_END_MS-elapsed)/(CUE_END_MS-FADE_START_MS));
      player.volume = BASE_VOLUME * portion;
    }
  }
  function playOnVisitorClick(){
    if(disposed || running || !houseAllowsSound()) return;
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    // Must happen inside this genuine balloon-click handler for Safari's
    // user-gesture audio restrictions; never start automatically on page load.
    if(!player){
      player = new Audio(AUDIO_URL);
      player.preload = 'none';
      player.loop = false;
    }
    try{
      player.pause();
      player.currentTime = 0;
      player.volume = BASE_VOLUME;
      running = true;
      begunAt = performance.now();
      var promise = player.play();
      if(promise && typeof promise.catch === 'function'){
        promise.catch(function(error){
          if(running){
            console.warn('[P&P Balloon Music] Playback blocked or source unavailable:',error && error.name);
            stop();
          }
        });
      }
      tickId = window.setInterval(update, 120);
      endId = window.setTimeout(stop, CUE_END_MS + 150);
    }catch(error){
      console.warn('[P&P Balloon Music] Unable to start:',error && error.name);
      stop();
    }
  }
  function onHouseSoundChange(){
    if(!houseAllowsSound()) stop();
    // Do not resume automatically after unmute; wait for another user click.
  }
  function onVisibilityChange(){
    if(document.hidden) stop();
  }
  function onSectionUnload(event){
    if(!event || !event.target || !event.target.contains(stage)) return;
    disposed = true;
    stop();
    balloon.removeEventListener('click', playOnVisitorClick);
    document.removeEventListener('pp:house-sound-change', onHouseSoundChange);
    window.removeEventListener('pp:house-sound-change', onHouseSoundChange);
    document.removeEventListener('visibilitychange', onVisibilityChange);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
  }

  balloon.addEventListener('click',playOnVisitorClick);
  document.addEventListener('pp:house-sound-change',onHouseSoundChange);
  window.addEventListener('pp:house-sound-change',onHouseSoundChange);
  document.addEventListener('visibilitychange',onVisibilityChange);
  document.addEventListener('shopify:section:unload',onSectionUnload);
})();
